import { render, staticRenderFns } from "./top-three.vue?vue&type=template&id=1fe00a19&scoped=true&"
import script from "./top-three.vue?vue&type=script&lang=js&"
export * from "./top-three.vue?vue&type=script&lang=js&"
import style0 from "./top-three.vue?vue&type=style&index=0&id=1fe00a19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe00a19",
  null
  
)

export default component.exports